var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumber5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 14.902c1.148 0 2.183.27 3.104.807a5.43 5.43 0 012.16 2.256c.52.975.779 2.1.779 3.377 0 2.233-.674 3.946-2.023 5.14-1.34 1.194-3.373 1.791-6.098 1.791-2.333 0-4.238-.36-5.715-1.08v-4.43c.793.365 1.686.666 2.68.903 1.002.237 1.864.355 2.584.355 1.002 0 1.772-.21 2.31-.628.538-.429.807-1.058.807-1.887 0-.766-.273-1.363-.82-1.791-.547-.428-1.377-.643-2.489-.643-.847 0-1.763.16-2.748.479l-1.982-.985.752-10.554h11.402v4.498H10.77l-.247 2.638c.711-.136 1.217-.21 1.518-.218.3-.018.579-.028.834-.028z",
    fill: "#fff",
    fillOpacity: 0.2
  })));
}

export default SvgNumber5;